import React, { useState, useEffect } from "react";
import { Collapse, Space } from 'antd';
import { useSelector } from "react-redux";
import { CompanyItemVo, COMPANY_INIT_STATE } from './config/interface';
import { generateClassName } from "jzfz-web-utils";
import { constantConfig } from 'web-common';
import { queryMenuContentList } from '../../store/action';

import './style/contactUs.less';


const { ModuleTypeEnum } = constantConfig;

// 背景图
const conactUsBgImg = require('../../assets/images/service/service-bg.jpg');
// 滤镜背景图
const conactUsFilterBgImg = require('../../assets/images/service/service-bg-filter.jpg');
// mobile
const conactUsMobileImg = require('../../assets/images/conactUs/conactUs-mobileBg.jpg');


/**
 * 联系
 * @constructor
 */
const ContactUs = () => {

	const { isMobile } = useSelector((state: any) => state.reducer); 

	const [activeKey, setActiveKey] = useState<string>(null);

	const [companyList, setCompanyList] = useState<CompanyItemVo[]>([]);


	useEffect(() => {
		initContentList();
	}, []);


	/**
	 * 初始化公司列表
	 */
	const initContentList = async () => {
		const result = await queryMenuContentList(ModuleTypeEnum.CONTACT);
		const arrs = result.data || [];
		if (Array.isArray(arrs)) {
			setCompanyList(arrs);
			setActiveKey((arrs[0] || {}).pkid);
		}
	};


	// 当前选择的公司
	const activeCompany = companyList.find(v => v.pkid === activeKey) || COMPANY_INIT_STATE;

	// 获取背景图片
	const getBannerImgUrl = () => {
		if (isMobile) {
			return conactUsMobileImg;
		}
		return activeCompany.contactName ? conactUsFilterBgImg : conactUsBgImg;
	};


	/**
	 * 渲染Mobile端联系我们
	 */
	const renderCompanyListMobile = () => {

		const option: CompanyItemVo = companyList.find(v => v.pkid === activeKey);

		return (
			<div className="contact-us-mobile-detail">
				<div className="w pb8 f40 brbd8 colorfff">
					联系我们
				</div>

				<div className="pt12"> 
					<div className="lh32 plr24">
						{
							companyList.map((v: CompanyItemVo, vi: number) => {
								return (
									<div 
										style={{width: '25%', color: activeKey === v.pkid ? '#FF1D38' : '#fff'}}
										className="dib" 
										key={v.pkid} 
										onClick={() => {
											if (activeKey === v.pkid) {
												// 已选中自己再点击时，取消
												setActiveKey(null);
												return;
											}
											setActiveKey(v.pkid);
										}}
									>
										{v.contactName}
									</div>
								);
							})
						}
					</div>	
					{
						option ? (
							<div className="ptb12 plr24 mt24 brbd8 brtd8 showConactUsInfo">
								<div>
									<span className="f28">{option.contactName}</span>
									<span className="f28 ml8">{option.englishName}</span>
								</div>
								<div><span>{option.address}</span></div>
								<div><span>{option.contactWay}</span></div>
							</div>
						) : null
					}
				</div>
			</div>
		);
	};


	/**
	 * 渲染PC端联系我们
	 */
	const renderCompanyListPC = () => {
		return (
			<div className="contact-us-detail">
				<div className="f64">联系我们</div>
				<div className="company">
					<div className="company-list">
						{
							companyList.map((v: CompanyItemVo, vi: number) => (
								<span 
									key={vi}
									className={generateClassName([
										"company-item",
										activeKey === v.pkid ? "active" : null
									])}
									onClick={() => {
										if (activeKey === v.pkid) {
											// 已选中自己再点击时，取消
											setActiveKey(null);
											return;
										}
										setActiveKey(v.pkid);
									}}
								>
									<span>{v.contactName}</span>
									<span>{v.englishName}</span>
								</span>
							))
						}
					</div>
					{
						activeCompany.contactName ? (
							<div className="company-active mt24">
								<div className="f28 mb8"><span className="pr12">{activeCompany.contactName}</span><span>{activeCompany.englishName}</span></div>
								<div>{activeCompany.address}</div>
								<div>{activeCompany.contactWay}</div>
							</div>
						) : null
					}
				</div>
			</div>
		);
	};


	return (
		<div className="company-contact-us-wrapper">
			<div className="contact-us-content">

				{/* 背景 */}
				<div className="w ofh">
					<img src={getBannerImgUrl()} className="w" />
				</div>

				{/* 内容 */}
				{isMobile ? renderCompanyListMobile() : renderCompanyListPC()}
			</div>
		</div>
	)
}


export default ContactUs;
